module.exports = __webpack_public_path__ + "media/images/photo/Agriculture/slider1-708a587c2f9f23fa7a717090e0194188.png";